import React from "react";
import PropTypes from "prop-types";

const borderStyle = { borderTop: "1px solid #000", padding: 5 };

const Signature = ({ renderValue }) => (
  <div style={{ paddingBottom: 10 }}>
    <table
      style={{
        width: "100%",
      }}
    >
      <tbody>
        <tr>
          <td
            style={{
              textAlign: "center",
              height: "20px",
              verticalAlign: "middle",
              width: "150px",
            }}
            rowSpan={2}
          >
            Yes, I Accept
            <br />
            <br />
            是，本人同意
          </td>
          <td
            style={{
              textAlign: "center",
            }}
          >
            {renderValue({
              fieldName: "EmployeeName",
              fieldFormat: "text",
            })}
          </td>
          <td
            style={{
              textAlign: "center",
              height: "20px",
              width: "50px",
              verticalAlign: "middle",
            }}
            rowSpan={2}
          >
            Date
            <br />
            <br />
            日期
          </td>
          <td
            style={{
              textAlign: "center",
              width: "250px",
              verticalAlign: "middle",
            }}
          >
            {renderValue({
              fieldName: "CompletedOn",
              fieldFormat: "date",
              dateFormat: "YYYY-MM-DD",
            })}
          </td>
        </tr>

        <tr>
          <td
            style={{
              textAlign: "center",
              ...borderStyle,
            }}
          >
            Signature of Employee/Member 僱員/會員簽名
          </td>
          <td
            style={{
              textAlign: "center",
              ...borderStyle,
            }}
          ></td>
        </tr>
      </tbody>
    </table>
  </div>
);

Signature.propTypes = {
  renderValue: PropTypes.func.isRequired,
};

export default Signature;



// WEBPACK FOOTER //
// ./components/employee/hdf-forms/Axa/AXAHD202404/Signature.js